// extracted by mini-css-extract-plugin
module.exports = {"approval-page__approval-deny":"index_approval-page__approval-deny_1QrRU"};